import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { RichDialogComponent } from '../../rich-dialog/rich-dialog.component';
import { TooltipBaseComponent } from '../tooltip-base/tooltip-base.component';

@Component({
    selector: 'app-dialog-tooltip',
    imports: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './dialog-tooltip.component.html',
})
export class DialogTooltipComponent implements TooltipBaseComponent {
    @Input() message: string = '';
    @Input() title: string = '';
    @Input() width: string = '500px';

    constructor(private dialog: MatDialog) {}

    openTooltipPopup() {
        if (this.dialog.openDialogs.length > 0) {
            return;
        }

        this.dialog.open(RichDialogComponent, {
            data: {
                title: this.title,
                content: this.message,
            },
            width: this.width,
            panelClass: 'dialog-tooltip',
        });
    }
}
